import React from "react";

import "boxicons";
import "../styles/portfolio.css";
import { newTab } from "../../App";

function PortfolioCard({
  appName = "Orange Lake Homes",
  category = "Web",
  appLink = "www.facebook.com",

  img,
}) {
  return (
    <div className="portfolio-wrap">
      <img src={img} className="img-fluid portfolio-img" alt="" />
      <div className="portfolio-info">
        <div className="portfolio-links">
          <a href={appLink} target="_blank" rel="noopener noreferrer" style={{color: "white"}}>
            <h5>{appName}</h5>
            <p>{category}</p>

            {/* <box-icon name="share-alt" color="white">
              
            </box-icon> */}
          </a>

          {/* <Link to="/">
            <box-icon name="share-alt" color="white">
              
            </box-icon>
          </Link> */}
        </div>
      </div>
    </div>
  );
}

export default PortfolioCard;
